var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1281,
    height: 53,
    viewBox: "0 0 1281 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-8.93555 0.0898438C-1.21853 4.63583 104.403 -5.07453 275.446 5.11137C446.49 15.2973 638.585 36.354 859.709 15.6515C1080.83 -5.05104 1209.91 -0.39352 1294.73 7.19356C1295.06 7.15442 1294.73 133.976 1294.73 133.976C1294.73 133.976 1132.83 146.442 969.203 137.236C805.578 128.031 522.727 131.593 522.727 131.593C362.144 144.354 129.131 159.352 -5.25904 146.119C-8.93559 145.753 -8.93555 0.0898438 -8.93555 0.0898438Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSmall);
export default __webpack_public_path__ + "static/media/footer-small.db4636fce644485ee5883bab97cd9a77.svg";
export { ForwardRef as ReactComponent };